import { QuestionSubmissionType } from '@/types/schema';

export enum ViewTypeEnum {
  Loading = 'LOADING',
  Question = 'QUESTION',
  Review = 'REVIEW',
  Error = 'ERROR',
  Preview = 'PREVIEW', //QP: remove
  ReviewQuestions = 'REVIEW_QUESTIONS', //QP: remove
  AttemptHistory = 'ATTEMPT_HISTORY', //QP: remove
}

export interface LoadingView {
  type: ViewTypeEnum.Loading;
}

export interface QuestionView {
  type: ViewTypeEnum.Question;
  index: number;
}

export interface ReviewView {
  type: ViewTypeEnum.Review;
}

export interface ErrorView {
  type: ViewTypeEnum.Error;
}

export type QuestionSubmissionById = Record<
  string,
  Pick<
    QuestionSubmissionType,
    'optionResponse' | 'mtfResponse' | 'ftbResponse' | 'imageHotspotResponse'
  >
>;

export type View = LoadingView | QuestionView | ReviewView | ErrorView;

export type SaveQuestionState = {
  isMutationInProgress: boolean;
  isDirty: boolean; // whether to submit question after inProgress mutation is completed
  index: number;
};
